import React, { FunctionComponent } from 'react';

import BarHeaderLayout from '@/pages/layouts/BarHeaderLayout';
import DestinationRegionPage from '@/components/pageComponents/DestinationRegionPage';
import { getDestinationsForRegion, getRegion } from '@/pageGeneration/services/prismicApi/landingPageDestinationsApi';
import PageSeo from '@/components/seo/PageSeo';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import mapResultsToIndexPageItems from '@/pageGeneration/services/mapResultsToIndexPageItems';
import useCustomPageViews from '@/utility/eventTracking/useCustomPageViews';
import { PAGE_CATEGORIES } from '@/utility/eventTracking/constants';
import UnprotectedPage from '@/components/navigation/UnprotectedPage';
import LandingPageService from '@/pageGeneration/services/LandingPageService';
import RouteHelper from '@jetslash/market-frontend-shared-core/src/utilities/navigation/RouteHelper';

interface IDestinationPlaceIndexItem {
  slug: string;
  title: string;
  url: string;
}

interface IProps {
  items: IDestinationPlaceIndexItem[];
  region: string;
  regionName: string;
}

const Region: FunctionComponent<IProps> = ({ items, region, regionName }) => {
  useCustomPageViews({ category: PAGE_CATEGORIES.LOCATIONS, name: `List/${region}` });

  const title = `Destinations (${regionName})`;
  return (
    <UnprotectedPage>
      <PageSeo title={title} noIndex />
      <BarHeaderLayout>
        <DestinationRegionPage items={items} title={title} />
      </BarHeaderLayout>
    </UnprotectedPage>
  );
};

export default Region;

export async function getStaticProps({ params }: { params: { region: string } }) {
  try {
    const regionParam = params.region;
    if (!LandingPageService.isValidRegionSlug(regionParam)) {
      return {
        notFound: true,
      };
    }
    const regionUid = regionParam.toLowerCase();
    console.log(`Get Destinations Region: ${regionUid}`);
    const regionResponse = await getRegion(regionUid);
    const regionData = regionResponse.results[0].data;
    const results = await getDestinationsForRegion(regionUid);

    const items = mapResultsToIndexPageItems(results, `${RouteHelper.destinationRegionPath(regionParam)}/`);
    return packageStaticProps({
      items,
      regionName: regionData.name,
      region: regionParam,
    });
  } catch (e) {
    console.log(`Destination region error ${params.region}`);
    console.log(e);
    return {
      notFound: true,
    };
  }
}

export async function getStaticPaths() {
  return {
    fallback: 'blocking',
    paths: [],
  };
}
